<template>
  <div class="jsc-bg">
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">运动竞训驾驶舱</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-column"
          style="width: 1920px; font-size: 18px"
        >
          <div class="d-aligncnter" style="padding: 24px">
            <div class="top-left d-column">
              <div class="left-top">
                <signin-info :signinList="signinList"></signin-info>
              </div>
              <div class="left-bottom">
                <div class="d-aligncnter">
                  <img src="@/assets/img/sportteam/line1.svg" class="" />
                  <span class="ml-8">重点关注（缺训次数）</span>
                  <img src="@/assets/img/sportteam/line2.svg" class="ml-8" />
                </div>
                <focus-on :importantList="importantList"></focus-on>
              </div>
            </div>
            <div class="top-center d-column">
              <div class="d-aligncnter d-between">
                <div class="d-aligncnter">
                  <img src="@/assets/img/sportteam/chart-histogram.svg" class="title-img" />
                  <span class="ml-8">运动队每日签到统计</span>
                </div>

                <div class="select-option">
                  <el-date-picker
                    v-model="currDate"
                    type="date"
                    placeholder="选择日期"
                    :clearable="false"
                    @change="DayDateChange"
                    :picker-options="maxOptions"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="echarts">
                <div id="barChart" style="width: 760px; margin: 0 auto; height: 460px"></div>
              </div>
            </div>
            <div class="top-right">
              <team-list :teamList="teamList"></team-list>
            </div>
          </div>
          <div class="bottom">
            <bottom-chart :monthRate="monthRate"></bottom-chart>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import MyScale from '../components/MyScale.vue'
import SigninInfo from './SigninInfo.vue'
import TeamList from './TeamList.vue'
import FocusOn from './FocusOn.vue'
import BottomChart from './BottomChart.vue'

import {
  getSportTeamSign,
  focusOnStudents,
  dailySportTeamSignStatistics,
  getSportTeamList,
  monthlyParticipationRates,
} from '@/api/api-competition'
export default {
  name: '',
  components: {
    MyScale,
    SigninInfo,
    TeamList,
    FocusOn,
    BottomChart,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      barOption: {},
      signinList: [],
      importantList: [],
      DailySportTeam: {},
      teamList: [],
      monthRate: {},
      currDate: '',
      maxOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },
  created() {
    let getMyDate = new Date()
    this.currDate = this.formatDate(getMyDate.getTime())
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
  },
  mounted() {
    this.sportTeamSign()
    this.getfocusOnStudents()
    this.getDailySportTeamSignStatistics()
    this.sportTeamList()
    this.getMonthlyParticipationRates()

    this.initBarChart()
    window.onresize = () => {
      return (() => {
        // this.initBarChart()
      })()
    }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      //   if (Number(size) < 1) {
      //     this.currScale = size
      //   }
      //   this.mySize = this.mySize / size
      this.mySize = 5.208 / size
      //   var myChart1 = this.$echarts.init(document.getElementById('totalNum'))
    },
    initBarChart() {
      var myChart = this.$echarts.init(document.getElementById('barChart'))
      this.barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          right: 20,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: this.DailySportTeam.teamName,
        },
        series: [
          {
            name: '参训人数',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: this.DailySportTeam.trainNum,
            itemStyle: {
              color: '#007A4D',
            },
          },
          {
            name: '缺席人数',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
            },
            emphasis: {
              focus: 'series',
            },
            data: this.DailySportTeam.lackTrainNum,
            itemStyle: {
              color: '#F97423',
            },
          },
        ],
      }
      myChart.setOption(this.barOption)
    },
    // 运动队实时签到信息
    sportTeamSign() {
      getSportTeamSign().then((res) => {
        console.log('res:', res)
        if (res.data.statusCode == 1) {
          this.signinList = res.data.obj
        }
      })
    },
    //重点关注学生(缺训次数)
    getfocusOnStudents() {
      focusOnStudents().then((res) => {
        console.log('res:', res)
        if (res.data.statusCode == 1) {
          this.importantList = res.data.obj
        }
      })
    },
    //运动队每日签到统计
    getDailySportTeamSignStatistics() {
      dailySportTeamSignStatistics(this.currDate).then((res) => {
        console.log('res:', res)
        if (res.data.statusCode == 1) {
          this.DailySportTeam = res.data.obj
          this.initBarChart()
        }
      })
    },
    //运动队列表
    sportTeamList() {
      getSportTeamList().then((res) => {
        console.log('res:', res)
        if (res.data.statusCode == 1) {
          this.teamList = res.data.obj
        }
      })
    },
    getMonthlyParticipationRates() {
      monthlyParticipationRates().then((res) => {
        console.log('res:', res)
        if (res.data.statusCode == 1) {
          this.monthRate = res.data.obj
        }
      })
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    DayDateChange() {
      console.log(this.formatDate(this.currDate))
      this.currDate = this.formatDate(this.currDate)
      this.getDailySportTeamSignStatistics()
    },
  },
}
</script>
<style lang="scss" scoped>
.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  //   background: #09120f;
  background: #09120f url('../../../assets/img/cockpit/home-bg.svg') no-repeat center;
  color: #fff;

  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;

    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }

    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }

    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }

    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}

.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}

.left-top {
  width: 480px;
  height: 264px;
  padding: 16px;
  background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
  overflow: hidden;
}
.left-bottom {
  width: 512px;
  height: 182px;
  margin-top: 24px;
  overflow: hidden;
}
.top-center {
  width: 768px;
  height: 475px;
  margin-left: 24px;
  padding: 16px;
  background: linear-gradient(180deg, rgba(26, 135, 95, 0.09) 0%, rgba(0, 122, 77, 0.18) 100%);
}
.top-right {
  width: 480px;
  height: 475px;
  padding: 16px;
  overflow: hidden;
  margin-left: 24px;
  background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
}
.bottom {
  width: 1840px;
  height: 377px;
  margin-left: 24px;
  padding: 16px;
  background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
  opacity: 0.9;
}
.ml-8 {
  margin-left: 8px;
}
.mt-16 {
  margin-top: 16px;
}
.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 105px;
  border: none;
  padding-right: 0px !important;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 105px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
